const ERROR_DESCRIPTIONS: Record<string, string> = {
  '63049': 'Meta recusou enviar esta mensagem de marketing',
  '63016': 'Janela de 24h expirada — use um template aprovado',
  '63032': 'Número não registrado no WhatsApp',
  '63024': 'Limite de mensagens atingido para este número',
  '21610': 'Contato optou por não receber mensagens (opt-out)',
  '21408': 'Permissão negada para enviar para esta região',
  '21211': 'Número de telefone inválido — verifique o cadastro do contato',
  '30003': 'Dispositivo de destino inacessível',
  '30005': 'Número de destino desconhecido ou inválido',
  '30006': 'Número bloqueado ou na lista negra',
  '30008': 'Número desconhecido',
};

export function getWhatsAppErrorDescription(errorCode?: string | null): string {
  if (!errorCode) return 'Erro de entrega — verifique o Twilio para mais detalhes';
  return ERROR_DESCRIPTIONS[errorCode] || `Erro ${errorCode} — verifique o Twilio para mais detalhes`;
}
